import { Button, Typography } from "@mui/material";
import CardsGroupComponent from "../../components/CardsGroupComponent/CardsGroupComponent";
import { SCREENS } from "../../utils/CommonUtils/screenConstants";
import { useTranslationSetup } from "../../utils/useTranslationSetup.js";
import "./styles.css";

const StartReadingScreen = ({ setActiveScreen, paraMetadata }) => {
  const { t } = useTranslationSetup();
  const image_url = window.location.origin + "/" + paraMetadata["path"];

  const handleNavigateToTestScreen = () => {
    setActiveScreen(SCREENS.RENDER_ORF_TEST_SCREEN);
  };

  return (
    <CardsGroupComponent>
      <Typography className="start-reading-display-text">
        {paraMetadata["title"]}
      </Typography>
      <img
        className="start-reading-image-source"
        src={image_url}
        alt="Reading"
      />
      <Button
        className="demo-start-reading-button"
        variant="contained"
        color="primary"
        onClick={handleNavigateToTestScreen}
      >
        {t("start_reading_text")}
      </Button>
    </CardsGroupComponent>
  );
};

export default StartReadingScreen;
